/**
 * props 에 @type 이 선언되면 좋겠지만 되지 않으므로
 * prop 을 computed 로 재선언하여 @type 선언을 할때 javascript type check warning 이 되지 않으려면 type 정보없이 prop 선언을 해야함.
 * 따라서 값은 null 일 뿐이지만 특정 type 을 사용한다는 의미의 마커로 사용
 */
export default null;
